import { successNotification, warningNotification } from "@app/common/components/notifications";
import { useAuthentication } from "@app/store/useAuthtentication";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  deleteDispensaryService,
  downloadPharmacyControlExcel,
  pharmacyControlService,
  requestAnnulDeliveryService
} from "./supportsConsult";
import { AnnulDeliveryPayload, PharmacyControlFilter } from "./types";
import { AxiosError } from "axios";
import { IResponse } from "@app/common/types/http";

export function useGetPharmacyControlList(filters: PharmacyControlFilter, enabled = true) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  const query = useQuery({
    enabled,
    gcTime: 0,
    queryKey: [
      "pharmacyControl",
      filters.page,
      filters.search,
      filters.site,
      filters.startDate,
      filters.endDate
    ],
    queryFn: async () => await pharmacyControlService(filters, token)
  });

  return {
    data: query.data?.results ?? [],
    rowTotal: query.data?.rowTotal ?? 0,
    refetch: query.refetch
  };
}

export const useDownloadPharmacyControlExcel = (filters: PharmacyControlFilter) => {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);

  return useQuery({
    enabled: false,
    gcTime: 0,
    queryKey: ["pharmacyControlExcel", filters],
    queryFn: async () => await downloadPharmacyControlExcel(filters, token)
  });
};

export function useDeleteDispensary(onSuccess = async () => {}) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (dispensaryId: number) => await deleteDispensaryService(dispensaryId, token),
    onSuccess: async (data) => {
      successNotification(data.message, "Actualizado exitosamente");
      queryClient.invalidateQueries({ queryKey: ["pharmacyControl"] });
      await onSuccess();
    },
    onError: async (error: AxiosError<IResponse>) => {
      warningNotification(error.response?.data?.message, "Intenta de nuevo");
    }
  });

  return mutation;
}

export function useRequestAnnulDelivery(onSuccess = async () => {}) {
  const token = useAuthentication((state) => state.auth.dataBiowel.token);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: AnnulDeliveryPayload) =>
      await requestAnnulDeliveryService(payload, token),
    onSuccess: async (data) => {
      successNotification(data.message, "Solicitud enviada exitosamente");
      queryClient.invalidateQueries({ queryKey: ["pharmacyControl"] });
      await onSuccess();
    },
    onError: async (error: AxiosError<IResponse>) => {
      warningNotification(error.response?.data?.message, "Intenta de nuevo");
    }
  });
}
